import { darkBackgroundBlur } from '@repo/ui/components/utilities';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { layoutConstants } from 'styles/layoutConstants';
import { FlexColumn, FlexContainer } from 'styles/layouts';

export const Label = styled.label`
  font-size: ${({ theme }) => theme.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight};
  color: ${({ theme, isActive }) => (isActive ? theme.darkColor : theme.color)};
  cursor: ${({ cursor }) => (cursor ? cursor : 'inherit')};
  transition: color 0.3s ease-in-out;

  &:hover {
    color: ${({ theme, doNotHover }) =>
      doNotHover ? theme.color : theme.darkColor};
  }
`;

export const RowWrapper = styled(FlexContainer)`
  align-items: center;
  height: 100%;
`;

export const OptionGroup = styled.div`
  display: inline-flex;
`;

export const OptionWrapper = styled.a`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: ${({ marginTop }) => marginTop};
  height: ${({ height }) => height};
  min-width: ${({ minWidth }) => minWidth};
  justify-content: ${({ justifyContent }) => justifyContent};
  &:hover {
    ${Label} {
      color: ${themeStyle.varInkMain};
    }
  }
`;

export const Separator = styled.div`
  height: 13px;
  width: 1px;
  background: ${({ theme }) => theme.color};

  margin-left: 16px;
  margin-right: 16px;
`;

export const Wrapper = styled.div`
  padding: 7px 15px 7px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow-x: scroll;
  height: ${layoutConstants.footerHeight};

  ${RowWrapper} {
    ${OptionWrapper} + ${OptionWrapper} {
      margin-left: 10px;
    }
    flex-shrink: 0;
  }

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;

  & > ${RowWrapper}:first-child {
    margin-right: 35px;
  }

  ${QUERIES.tabletAndUp} {
    padding: 7px 45px;
  }
`;

export const FooterWrapper = styled.footer`
  width: 100%;
  background-color: ${({ theme }) => theme.backgroundColor};
  border-top: 1px solid ${({ theme }) => theme.borderColor};
  color: ${({ theme }) => theme.color};
  position: fixed;
  bottom: 0;
  z-index: ${themeStyle.zIndexS2};

  ${darkBackgroundBlur}
`;

export const MoreWrapper = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
`;

export const PopoverChildren = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    path {
      fill: ${({ theme }) => theme.darkColor};
    }

    ${Label} {
      color: ${({ theme }) => theme.darkColor};
    }
  }
`;

export const ArrowWrapper = styled(FlexContainer)`
  flex-shrink: 0;

  /* rotate content */
  div {
    transform: rotate(${({ isActive }) => (isActive ? '0' : '180')}deg);
    transition: transform 0.5s;
  }
`;
